import { axiosClient } from '@nx-frontend/shared/api';
import { generalEnv } from '@nx-frontend/shared/env';
import { GetOrganizationParams, OrgMembersCountResult } from '@nx-frontend/shared/types';

export async function getOrgMembersCount({ globalId }: GetOrganizationParams): Promise<OrgMembersCountResult | null> {
  let result: OrgMembersCountResult | null = null;

  try {
    const response = await axiosClient.get<OrgMembersCountResult>(
      `${generalEnv.orgServiceUrl}/v1/orgs/${globalId}/countMembers`,
      {
        headers: {
          'Authorization': `internal 0:auto`,
          'x-secret': generalEnv.superSecret,
        },
      }
    );
    result = response.data;
  } catch (err) {
    console.error(`getOrgMembersCount error: ${err}`);
  }

  return result;
}
